export default __webpack_public_path__ + "48b1c189ab0f7ffcbbbec516ead84c9a.jpg";